// import { useMemo } from "react";
// import { useSelector } from "react-redux";
// import { PRODUCT_FORM_CONFIG  } from "../Config/productFormConfig";

// const useProductConfiguration = () => {

//     const admin = useSelector((state) => state.auth.admin);

//     return useMemo(() => {

//         if (!admin) {
//             return PRODUCT_FORM_CONFIG.default;
//         }

//         const slug =
//             admin?.subcategory?.slug?.toLowerCase() ||
//             admin?.subcategory?.name?.toLowerCase() ||
//             "default";

//         return (
//             PRODUCT_FORM_CONFIG[slug] ||
//             PRODUCT_FORM_CONFIG.default
//         );

//     }, [admin]);
//     console.log("Admin", admin);
// console.log("Slug", admin?.subcategory?.slug);
// console.log("Config", config);

// };

// export default useProductConfiguration;

// Product/hooks/useProductConfiguration.js
// import { useMemo } from 'react';
// import { useSelector } from 'react-redux';
// import { getProductConfig } from '../config/productConfiguration';

// const useProductConfiguration = () => {
//   const admin = useSelector((state) => state.auth.admin);
  
//   return useMemo(() => {
//     // Get subcategory slug from admin
//     const subcategorySlug = admin?.subcategory?.slug || 
//                           admin?.subcategory?.name || 
//                           admin?.subcategory || 
//                           'default';
    
//     return getProductConfig(subcategorySlug);
//   }, [admin]);
// };

// export default useProductConfiguration;

import { getProductConfig } from "../Config/getProductConfig";

const useProductConfiguration = (subcategorySlug) => {
    return getProductConfig(subcategorySlug);
};

export default useProductConfiguration;